import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { ButtonPrimary, ButtonSecondary, When, HSpacer, colors, LoadingDot, Text, Title } from '@aftersale-next/ui';

var ReceivedConfirm = function ReceivedConfirm(props) {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var onClose = props.onClose,
      isLoading = props.isLoading,
      isError = props.isError,
      onConfirm = props.onConfirm;

  var getButtonText = function getButtonText() {
    if (isLoading) return /*#__PURE__*/_jsx(LoadingDot, {});
    if (isError) return t('TRY_AGAIN');
    return t('RECEIVED_ORDER');
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Title, {
      center: true,
      fontSize: "0.875rem",
      transform: "uppercase",
      color: isError && colors.red,
      children: [/*#__PURE__*/_jsx(When, {
        value: !isError,
        children: t('DELIVERY_CONFIRMATION')
      }), /*#__PURE__*/_jsx(When, {
        value: isError,
        children: t('DELIVERY_CONFIRMATION_ERROR')
      })]
    }), /*#__PURE__*/_jsx(HSpacer, {
      space: "24px"
    }), /*#__PURE__*/_jsxs(Text, {
      center: true,
      size: "16px",
      children: [/*#__PURE__*/_jsx(When, {
        value: !isError,
        children: t('DELIVERY_CONFIRMATION_DESCRIPTION')
      }), /*#__PURE__*/_jsx(When, {
        value: isError,
        children: t('DELIVERY_CONFIRMATION_ERROR_DESCRIPTION')
      })]
    }), /*#__PURE__*/_jsx(HSpacer, {
      space: "32px"
    }), /*#__PURE__*/_jsx(ButtonPrimary, {
      disabled: isLoading,
      bgColor: colors.green,
      onClick: onConfirm,
      children: getButtonText()
    }), /*#__PURE__*/_jsx(HSpacer, {
      space: "8px"
    }), /*#__PURE__*/_jsxs(ButtonSecondary, {
      disabled: isLoading,
      bgColor: colors.buttonForeground,
      borderColor: colors.gray,
      textColor: colors.gray,
      onClick: onClose,
      children: [/*#__PURE__*/_jsx(When, {
        value: !isError,
        children: t('DENY_AND_GO_BACK')
      }), /*#__PURE__*/_jsx(When, {
        value: isError,
        children: t('BACK')
      })]
    })]
  });
};

export default ReceivedConfirm;